import { render, staticRenderFns } from "./authResult.vue?vue&type=template&id=32ae1e8d&scoped=true"
import script from "./authResult.vue?vue&type=script&lang=js"
export * from "./authResult.vue?vue&type=script&lang=js"
import style0 from "./authResult.vue?vue&type=style&index=0&id=32ae1e8d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ae1e8d",
  null
  
)

export default component.exports